import { render, staticRenderFns } from "./lost-connection-popup.vue?vue&type=template&id=063c881d&"
import script from "./lost-connection-popup.vue?vue&type=script&lang=js&"
export * from "./lost-connection-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports